/**
 * Canonical path for a directory location page. Mirrors the server's
 * directoryCanonicalPath (server/src/routes/ssrMeta.ts) so the client's
 * react-helmet canonical matches the SSR-injected one — otherwise Google's JS
 * render would re-point the canonical to the current mode/URL.
 *
 * All 4 directory modes are filters of the same location, so they canonicalise
 * to the /plumbers view; a leaf town that just repeats its county (unitary
 * authority, e.g. /bristol/bristol) is dropped to the county page.
 */
export function directoryCanonicalPath(
  countrySlug?: string,
  countySlug?: string,
  townSlug?: string,
  postcodeSlug?: string,
): string {
  const parts = ['plumbers']
  if (countrySlug) parts.push(countrySlug)
  if (countySlug) parts.push(countySlug)
  if (townSlug && !(townSlug === countySlug && !postcodeSlug)) parts.push(townSlug)
  if (postcodeSlug) parts.push(postcodeSlug)
  return `/${parts.join('/')}`
}
